import {Component, OnInit, ViewChild} from '@angular/core';
import {FormsService} from '../shared/services/databaseServices/forms/forms.service';
import {RacesService} from '../shared/services/databaseServices/races/races.service';
import {FormBuilder} from '@angular/forms';
import {RacerService} from '../shared/services/databaseServices/racer/racer.service';
import {toArray} from 'rxjs/operators';
import {faMoneyCheckAlt} from '@fortawesome/free-solid-svg-icons/faMoneyCheckAlt';
import {FioService} from '../shared/services/databaseServices/fioService/fio.service';
import {FioConfig} from '../shared/classes/FioConfig';
import {ActivatedRoute, Router} from '@angular/router';
import {FioLine} from '../shared/classes/FioLine';
import {Race} from '../shared/classes/Race';
import {DialogComponent} from '../dialog/dialog.component';
import {MatDialog} from '@angular/material';
import {DatePipe} from '@angular/common';
import {EmailService} from '../shared/services/emailService/email.service';
import {Racer} from '../racer-tab/Racer';
import {EmailTableService} from '../shared/services/databaseServices/emailTable/email-table.service';
import {EmailTable} from '../shared/classes/EmailTable';
import {LocalStorageService} from '../shared/services/localStorageService/local-storage.service';
import {faDownload, faUpload} from '@fortawesome/free-solid-svg-icons';
import {FileService} from '../shared/services/fileService/file.service';
import {ChipItem} from '../shared/classes/ChipItem';

@Component({
  selector: 'app-all-racers',
  templateUrl: './all-racers.component.html',
  styleUrls: ['./all-racers.component.css'],
  providers: [DatePipe]
})
export class AllRacersComponent implements OnInit {

  @ViewChild('fileInputButton', {static: false})
  fileInputButton;

  file: File | null = null;
  fileName = '';

  faMoneyCheck = faMoneyCheckAlt;
  faDownload = faDownload;
  fioConfig: FioConfig = new FioConfig();
  id = undefined;
  emptyForm = this.formBuilder.group({});
  isNew = false;
  plusButton = true;
  editButton = false;
  createTooltip = 'raceDetailPage.startFeeTab.saveToolTip';
  deleteTooltip = 'raceDetailPage.startFeeTab.deleteToolTip';
  addTooltip = 'raceDetailPage.startFeeTab.addToolTip';
  fioLines: FioLine[] = [];
  faUpload = faUpload;

  racers = undefined;

  displayedColumns: string[] = ['name', 'surname', 'club', 'category', 'pay', 'paid', 'vs'];

  header = [
    {
      defName: 'name',
      translation: 'racesPage.racers.tabs.name',
      elem: 'name'
    },
    {
      defName: 'surname',
      translation: 'racesPage.racers.tabs.surname',
      elem: 'surname'
    },
    {
      defName: 'club',
      translation: 'racesPage.racers.tabs.club',
      elem: 'club'
    },
    {
      defName: 'category',
      translation: 'racesPage.racers.tabs.category',
      elem: 'category'
    },
    {
      defName: 'pay',
      translation: 'racesPage.racers.tabs.pay',
      elem: 'pay'
    },
    {
      defName: 'paid',
      translation: 'racesPage.racers.tabs.paid',
      elem: 'paid'
    },
    {
      defName: 'vs',
      translation: 'accountInfo.vs',
      elem: 'vs'
    }
  ];

  constructor(private formsService: FormsService,
              private activatedRoute: ActivatedRoute,
              private fileService: FileService,
              private racesService: RacesService,
              private emailTableService: EmailTableService,
              private racerService: RacerService,
              private router: Router,
              private localStorageService: LocalStorageService,
              private datePipe: DatePipe,
              private emailService: EmailService,
              public dialog: MatDialog,
              private fioService: FioService,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.loadForm();
    this.loadRacersByRace();

    if(this.racesService.race === undefined){
      this.racesService.getOne(this.id).then(data => {
        this.racesService.race = new Race();
        this.racesService.raceId = data.id;
        this.racesService.race = data.data();
      });
    }
  }

  translateObject(list){

  }

  downloadCsv() {
    const header = ['name', 'surname', 'year', 'sex', 'category', 'track', 'club','city', 'startFee', 'paid', 'mobile', 'email', 'note', 'familyTandem', 'team', 'startNumber', 'voucher', 'lunch'];
    console.dir(this.racers);
    this.fileService.downloadCsv(this.racers, header, this.racesService.race.name);
  }

  toArray(data) {
    const arr = [];
    data.forEach(item => {
      const racer = item.data();
      racer.id = item.id;
      arr.push(racer);
    });
    return arr;
  }

  loadRacersByRace() {
    this.racerService.getRacers().then(data => {
      this.racers = this.toArray(data).filter(i => i.raceId === this.racesService.raceId);
    });
  }

  loadForm() {
    this.formsService.getForms().then(data => {
      data.forEach(item => {
        if (item.data().race.id === this.racesService.raceId) {
        }
      });
    });
  }

  save(item) {

  }

  delete(item) {

  }

  add(item) {
    this.router.navigate(['/admin/races/racer', 'new']);
  }

  edit(item) {
    this.localStorageService.create('racerId', item.id);
    this.localStorageService.create('raceId', this.id);
    this.racerService.racer = item;
    this.router.navigate(['/admin/races/racerPay', this.racesService.raceId]);
  }

  checkPayments() {
    this.loadFioConfig();
  }

  private createMessage(racer: Racer): string{
    let message = '';
    message = `Dobrý den, <br>`;
    message = `${message} přijali jsme platbu startovného<br>`;
    message = `${message} <b> Název závodu: </b> ${this.racesService.race.name} <br>`;
    message = `${message} <b> Jméno a přijmení: </b> ${racer.name} ${racer.surname} <br>`;
    message = `${message} <b> Kategorie: </b> ${racer.category} <br>`;
    message = `${message} <b> Variabliní symbol: </b> ${racer.vs} <br><br>`;

    message = `${message} Těšíme se na Vás na startu`;

    return message;
  }

  private sendEmailDb(racer: Racer) {
    this.emailTableService.getOne(this.racesService.raceId).then(data => {
      const toEmail = racer.email;
      const email: EmailTable = data.data().emails.filter(i => i.messageType.toLowerCase() === EmailTable.ON_PAY.toLowerCase())[0];

      let message = email.onPayMessage;
      message = message.replace(EmailTable.key_name, racer.name);
      message = message.replace(EmailTable.key_surname, racer.surname);
      message = message.replace(EmailTable.key_varSym, racer.vs);

      this.emailService.sendEmail(email.onPayFrom, toEmail, email.onPaySubject, message);
    });
  }

  private sendEmail(racer: Racer, subject, message){
    const fromEmail = this.racesService.race.emailOr;
    const toEmail = racer.email;

    this.emailService.sendEmail(fromEmail, toEmail, subject, message).then(data => {
    });
  }

  private loadFioConfig() {
    this.fioService.getOne(this.racesService.race.fioConfig.profile).then(data => {
      this.fioConfig = new FioConfig();
      this.fioConfig.id = data.id;
      this.fioConfig.token = data.data().token;
      this.fioConfig.profile = data.data().profile;
      this.fioConfig.dateFrom = this.racesService.race.fioConfig.dateFrom;

      const a: any = this.fioConfig.dateFrom;
      const t = this.datePipe.transform(a.toDate(), 'yyyy-MM-dd');


      this.loadPayments(this.fioConfig.token, t, this.fioService.formatString(new Date()));
    });
  }

  filterByPaid = "all"

  filterPay(filter: string) {
    this.filterByPaid = filter;
  }

  private openDialog(header, text, button, info, danger){
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '250px',
      data: {
        header: header,
        text: text,
        actionButton: button,
        info: info,
        danger: danger
      }
    });
    return dialogRef;
  }

  loadFile() {
    const files: {[key: string]: File} = this.fileInputButton.nativeElement.files;

    this.fileService.loadFileAsText(files).onload = () => {
      this.fileName = this.fileService.name;
      const csv: string = this.fileService.reader.result as string;
      this.exportXML(csv);
    };
  }

  parseFile(csv: string): ChipItem[] {
    const chips: ChipItem[] = [];
    const lines: string[] = csv.split('\n');

    for(let lineIndex = 1; lineIndex < lines.length; lineIndex++) {
      const chipItem: ChipItem = new ChipItem();
      const parsed: string[] = lines[lineIndex].split(';');
      chipItem.id = parsed[0];
      chipItem.startNum = parsed[1];
      chips.push(chipItem);
    }
    return chips;
  }

  fileInput() {
    this.fileInputButton.nativeElement.click();
  }

  exportXML(csv:string) {
    const chipes: ChipItem[] = this.parseFile(csv);
    let xmlString: string = '';
    let i = 1;
    let chipId = 0;
    xmlString = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n`;
    xmlString = `${xmlString}<root xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">\n`;
    this.racers.forEach(racer => {
      const trackShort = this.racesService.race.track.filter(t => t.track === racer.track)[0].trackShort;

      xmlString = `${xmlString}\t<racer>\n`;
      xmlString = `${xmlString}\t\t<race>${trackShort}</race>\n`;
      xmlString = `${xmlString}\t\t<category>${racer.category}</category>\n`;
      xmlString = `${xmlString}\t\t<firstName>${racer.name}</firstName>\n`;
      xmlString = `${xmlString}\t\t<lastName>${racer.surname.toUpperCase()}</lastName>\n`;
      xmlString = `${xmlString}\t\t<startNumber>${chipes[chipId].startNum}</startNumber>\n`;
      xmlString = `${xmlString}\t\t<chip1>${chipes[chipId].getId2()}</chip1>\n`;
      xmlString = `${xmlString}\t\t<chip2>${chipes[chipId].id}</chip2>\n`;
      xmlString = `${xmlString}\t\t<gender>${racer.sex.toLowerCase() === 'muž' ? 'M' : 'F'}</gender>\n`;
      xmlString = `${xmlString}\t\t<club>${racer.club}</club>\n`;
      xmlString = `${xmlString}\t\t<state>CZ</state>\n`;
      xmlString = `${xmlString}\t\t<racingStatus>REG</racingStatus>\n`;
      xmlString = `${xmlString}\t\t<orderIndex>${i}</orderIndex>\n`;
      xmlString = `${xmlString}\t\t<phone>${racer.mobile}</phone>\n`;
      xmlString = `${xmlString}\t\t<email>${racer.email}</email>\n`;
      xmlString = `${xmlString}\t\t<poznamka>${racer.note}</poznamka>\n`;
      xmlString = `${xmlString}\t\t<poznamka2>${racer.note}</poznamka2>\n`;
      xmlString = `${xmlString}\t</racer>\n`;
      i++;
      chipId++;
    });
    xmlString = `${xmlString}</root>`;
    this.fileService.downloadFile(xmlString);
  }

  private loadPayments(token, fromDate, toDate) {
    this.fioService.getFioTransaction(token, fromDate, toDate).then(data => {
      let count = 0;
      this.fioLines = this.fioService.parseFioData(data);

      const fioRacers = this.racers.filter(i => i.pay.toLowerCase() === 'převodem' && !i.paid);

      fioRacers.forEach(racer => {
        const vs = racer.vs;
        if (this.fioLines.map(line => line.varSym).includes(String(vs))) {
          racer.paid = true;
          racer.timeOfPay = new Date();
          this.sendEmailDb(racer);
          count++;
          this.racerService.update(racer).then(() => {
          }).catch(err => {
            console.dir(err);
          });
        }
      });

      let dialogRef;
      if (count > 0) {
        dialogRef = this.openDialog('racesPage.modalPaid.header', 'racesPage.modalPaid.success', 'raceDetailPage.modal.startFeeClose', true, false);
      } else {
        dialogRef = this.openDialog('racesPage.modalPaid.header', 'racesPage.modalPaid.successZero', 'raceDetailPage.modal.startFeeClose', true, false);
      }
      dialogRef.afterClosed().subscribe(result => {
      });

    }).catch(err => {
      console.dir(err);
      const errDialog = this.openDialog('racesPage.modalPaid.header', 'racesPage.modalPaid.failed', 'raceDetailPage.modal.startFeeClose', false, true);
      errDialog.afterClosed().subscribe(result => {
      });
    });
  }

}
